import PaintProcurementCatalogWorkspace from '../../placeholders/PaintProcurementCatalogWorkspace';

export default PaintProcurementCatalogWorkspace;
